// extracted by mini-css-extract-plugin
export default {"Layout":"DefaultLayout_Layout__4cMR2","Children":"DefaultLayout_Children__7oDLW"};